module.exports = __webpack_public_path__ + "static/media/mlh.53dd27a8.png";